import React from 'react';

const PageTitle = (props) => {
    return(
        <div className="inr_top_page_title">
            <h2>{props.title}</h2>
        </div>
    )
}

export default PageTitle;